<template>
  <div class="mb-10 animate__animated animate__fadeIn animate__delay-1s">
    <div class="text-center pt-10 ant-title font-weight-bolder ant-font-viga">Sekilas Sejarah PKK Provinsi Banten</div>
    <div class="mt-10">
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-row class="justify-content-center">
              <img
                src="images/keluarga.png"
                alt=""
                srcset=""
                width="500"
              >

            </v-row>

          </v-col>
          <v-col cols="6">
            <p
              style="text-align: justify;"
              class="body-2"
            >
              Pemberdayaan Kesejahteraan Keluarga (PKK) sebagai gerakan pembangunan masyarakat bermula dari seminar Home Economic di Bogor tahun 1957. Sebagai tindak lanjut dari seminar tersebut, pada tahun 1961 panitia penyusunan tata susunan pelajaran pada Pendidikan Kesejahteraan Keluarga (PKK), Kementerian Pendidikan bersama kementerian-kementerian lainnya menyusun 10 segi kehidupan keluarga. Gerakan PKK dimasyarakatkan berawal dari kepedulian istri gubernur Jawa Tengah pada tahun 1967 (ibu Isriati Moenadi) setelah melihat keadaan masyarakat yang menderita busung lapar.

            </p>
            <p
              style="text-align: justify;"
              class="body-2"
            >
              Upaya untuk meningkatkan kesejahteraan keluarga melalui 10 segi pokok keluarga dengan membentuk Tim Penggerak PKK di semua tingkatan, yang keanggotaan timnya secara relawan dan terdiri dari tokoh/pemuka masyarakat, para isteri kepala dinas/jawatan dan isteri kepala daerah s.d tingkat desa dan kelurahan yang kegiatannya didukung dengan anggaran pendapatan dan belanja daerah.

            </p>

            <p
              style="text-align: justify;"
              class="body-2"
            >
              Pada tanggal 27 Desember 1972 mendagri mengeluarkan surat kawat no. Sus 3/6/12 kepada seluruh gubernur kdh tk. I Jawa Tengah dengan tembusan gubernur kdh seluruh indonesia, agar mengubah nama pendidikan kesejahteraan keluarga menjadi pembinaan kesejahteraan keluarga. Sejak itu gerakan PKKdilaksanakan di seluruh Indonesia dengan nama Pembinaan Kesejahteraan Keluarga (PKK), dan tanggal 27 Desember ditetapkan sebagai "hari kesatuan gerak PKK" yang diperingati pada setiap tahun.

            </p>
          </v-col>
        </v-row>

      </v-container>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "sekilas-component",
};
</script>